import { campusApiClient, Spinner } from '@datacamp/campus-integration';
import { CompletionPane } from '@datacamp/le-shared-components';
import React, { useCallback, useEffect, useState } from 'react';
import VideoExercise from '../components/VideoExercise';
import config from '../config';
import { DEFAULT_USER_LANGUAGE } from '../constants/i18n';
import { trackPlayerEvent } from '../trackPlayerEvent';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const VideoExerciseCompatibilityWrapper = _ref => {
  var _user$isLoggedIn, _user$language;
  let {
    callbacks,
    environment,
    exercise,
    id,
    user
  } = _ref;
  const {
    onExerciseFinished,
    onExerciseReady,
    onExerciseSubmitted
  } = callbacks;
  const onVideoCompleteWithoutRatingCheck = useCallback(() => {
    onExerciseSubmitted({
      correct: true,
      id,
      message: '',
      submission: ''
    });
    onExerciseFinished({
      id
    });
  }, [id, onExerciseSubmitted, onExerciseFinished]);
  const [isComplete, setIsComplete] = useState(false);
  const onVideoComplete = useCallback(() => {
    setIsComplete(true);
    if (exercise !== null && exercise !== void 0 && exercise.isRatingPermitted) {
      return;
    }
    onVideoCompleteWithoutRatingCheck();
  }, [exercise, onVideoCompleteWithoutRatingCheck, setIsComplete]);
  const onRate = React.useCallback(async payload => {
    try {
      await campusApiClient(environment).rateExercise(id, payload);
    } catch (error) {}
  }, [environment, id]);
  useEffect(() => {
    setIsComplete(false);
    onExerciseReady({
      id
    });
  }, [id, onExerciseReady]);
  if (exercise == null) {
    return ___EmotionJSX(Spinner, null);
  }
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(VideoExercise, {
    campusApiUrl: config(environment).urls.CAMPUS_API,
    environment: environment,
    exercise: {
      assignment: exercise.assignment,
      id,
      projectorKey: exercise.video.projector_key,
      title: exercise.title,
      videoHls: exercise.video.video_hls,
      videoLink: exercise.video.video_link,
      xp: exercise.xp
    },
    isActive: !isComplete,
    isLoggedIn: (_user$isLoggedIn = user === null || user === void 0 ? void 0 : user.isLoggedIn) !== null && _user$isLoggedIn !== void 0 ? _user$isLoggedIn : false,
    language: (_user$language = user === null || user === void 0 ? void 0 : user.language) !== null && _user$language !== void 0 ? _user$language : DEFAULT_USER_LANGUAGE,
    onComplete: onVideoComplete,
    projectorUrl: config(environment).urls.PROJECTOR,
    setIsComplete: setIsComplete,
    trackPlayerEvent: trackPlayerEvent,
    userId: user === null || user === void 0 ? void 0 : user.id
  }), exercise !== null && exercise !== void 0 && exercise.isRatingPermitted && isComplete ? ___EmotionJSX(CompletionPane, {
    message: '',
    onClose: onVideoCompleteWithoutRatingCheck,
    onContinue: onVideoCompleteWithoutRatingCheck,
    onRate: exercise !== null && exercise !== void 0 && exercise.isRatingPermitted ? onRate : undefined,
    xp: exercise === null || exercise === void 0 ? void 0 : exercise.xp
  }) : null);
};